import React from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo } from 'types';
import { ModificationsDishMultipleSelect } from './components/ModificationsDishMultipleSelect';
import { DnDList } from './components/DnDList';
import style from './index.module.scss';

interface IProps {
	setFetchedModificationsDishes: (value: IItemForGetShortInfo[]) => void;
	setModificationsDishCategory: (value: Nullable<string>) => void;
	setModificationsDishSubCategory: (value: Nullable<string>) => void;
	setModificationsDishes: (value: string[]) => void;
	removeModificationsDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedModificationsDishCategory: Nullable<string>;
	selectedModificationsDishSubCategory: Nullable<string>;
	selectedModificationsDishes: string[];
	fetchedModificationsDishes: IItemForGetShortDishInfo[];
}

export const ModificationsDishesField: React.FC<IProps> = React.memo(
	({
		setFetchedModificationsDishes,
		setModificationsDishCategory,
		setModificationsDishSubCategory,
		setModificationsDishes,
		removeModificationsDish,
		IDsSelectedRestaurant,
		selectedModificationsDishCategory,
		selectedModificationsDishSubCategory,
		selectedModificationsDishes,
		fetchedModificationsDishes,
	}) => {
		return (
			<div className={style.container} data-test="ModificationsDishesField">
				<ModificationsDishMultipleSelect
					setFetchedModificationsDishes={setFetchedModificationsDishes}
					setModificationsDishCategory={setModificationsDishCategory}
					setModificationsDishSubCategory={setModificationsDishSubCategory}
					setModificationsDishes={setModificationsDishes}
					removeModificationsDish={removeModificationsDish}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					selectedModificationsDishCategory={selectedModificationsDishCategory}
					selectedModificationsDishSubCategory={selectedModificationsDishSubCategory}
					fetchedModificationsDishes={fetchedModificationsDishes}
					selectedModificationsDishes={selectedModificationsDishes}
				/>
				<DnDList
					selectedModificationsDishes={selectedModificationsDishes}
					fetchedModificationsDishes={fetchedModificationsDishes}
					setModificationsDishes={setModificationsDishes}
					removeModificationsDish={removeModificationsDish}
				/>
			</div>
		);
	},
);
